import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider, MutationCache } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AuthProvider } from './utilities/AuthProvider';
import { ToastProvider } from './utilities/ToastProvider';
import { ConditionalRenderContextProvider } from './utilities/ConditionalRenderContextProvider';
import { LoadingContextProvider } from './utilities/LoadingContextProvider';
import { LangContextProvider } from './utilities/LangContextProvider';
import { FeatureFlagProvider } from './utilities/FeatureFlagProvider';

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error) => console.error("Unhandled mutation error:", error),
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      // Safety net for the cross-role stale-state bug class — refetches only
      // queries already past staleTime (5 min), so cost is bounded. Switching
      // tabs is the most common trigger for "data didn't update" reports.
      refetchOnWindowFocus: true,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <FeatureFlagProvider>
            <LangContextProvider>
              <ConditionalRenderContextProvider>
                <LoadingContextProvider>
                  <ToastProvider>
                    <App />
                  </ToastProvider>
                </LoadingContextProvider>
              </ConditionalRenderContextProvider>
            </LangContextProvider>
          </FeatureFlagProvider>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

